import { Box, BoxProps, Text } from '@chakra-ui/react';

export interface Props extends BoxProps {
  title: string;
  children: React.ReactNode;
}

export const FilterSection: React.FC<Props> = ({
  title,
  children,
  ...props
}) => (
  <Box marginTop="24px" {...props}>
    <Text fontSize="lg" fontWeight="500" color="primary.600">
      Audience {title}
    </Text>
    <Text fontSize="md" fontWeight="400" color="primary.400">
      Select one option
    </Text>
    {children}
  </Box>
);
